export type GeneralAddress = {
    addressLine1: string;
    city: string;
    state: string;
    zipCode: string;
};

export class GoogleMapAPI {
    // private autocomplete: google.maps.places.Autocomplete | null = null;
    // private multipleAutocomplete: Record<string, google.maps.places.Autocomplete | null> = {};

    // loadGoogleMap(apiKey: string, callback?: () => void): void {
    //     const existingScript = document.getElementById('googlePlacesScript');

    //     if (!existingScript) {
    //         const script = document.createElement('script');
    //         script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initAutocomplete&libraries=places&v=weekly`;
    //         script.id = 'googlePlacesScript';
    //         document.body.appendChild(script);

    //         // Attach a global callback
    //         (window as any).initAutocomplete = () => {
    //             if (callback) {
    //                 console.log('callback: ', callback());
    //                 callback();
    //             }
    //         };

    //         // script.onload = () => {
    //         //     if (callback) {
    //         //         callback();
    //         //     }
    //         // };

    //         script.onerror = () => {
    //             console.log('Failed to load Google Maps API.');
    //         };
    //     } else if (callback) {
    //         callback();
    //     }
    // }

    loadGoogleMap(apiKey: string, callback: () => void): void {
        const existingScript = document.getElementById('googlePlacesScript');

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly`;
            script.id = 'googlePlacesScript';
            document.body.appendChild(script);
    
            script.onload = () => {
                callback(); // Call the provided callback when the script loads
            };
    
            script.onerror = () => console.log('Failed to load Google Maps API.');
        } else {
            callback();
        }
    }

    unloadGoogleMap(): void {
        const script = document.getElementById('googlePlacesScript');
        if (script) {
            script.remove();
            console.log('Google Maps API script removed.');
        } else {
            console.log('No Google Maps script to unload.');
        }

        // Reset the global Google Maps object
        // if (window.google && window.google.maps) {
        //     delete window.google.maps;
        //     console.log('Google Maps API resources cleared.');
        // }
    }

    // initAutocomplete(inputElementId: string, autocomplete: google.maps.places.Autocomplete | null, onPlaceChanged: (place: google.maps.places.PlaceResult, generalAddress: GeneralAddress) => void): void {
    //     console.log('google api run: ', inputElementId);
    //     try {
    //         var inputElement = document.getElementById(inputElementId) as HTMLInputElement;

    //         if (inputElement) {
    //             console.log('inputElement: ', inputElement);
    //             console.log('test: ', document.scripts);
    //             autocomplete = new google.maps.places.Autocomplete(inputElement, {
    //                 componentRestrictions: { country: ['us', 'ca'] },
    //                 fields: ['address_components', 'geometry'],
    //                 types: ['address'],
    //             });

    //             // Listener for successful place selection
    //             autocomplete.addListener('place_changed', () => {
    //                 const place = autocomplete?.getPlace();
    //                 if (place && place.address_components) {
    //                     const generalAddress = this.extractAddressFields(place);
    //                     onPlaceChanged(place, generalAddress);
    //                 }
    //             });
    //             // Listener for adding eror handling
    //             google.maps.event.addListener(autocomplete, 'error', this.handleError);
    //         } else {
    //             console.log('inputElement is null', inputElement);
    //         }
    //     } catch (error) {
    //         console.log('Failed to initialize autocomplete:', error);
    //     }
    // }

    initAutocomplete(
        inputElementId: string,
        autocomplete: google.maps.places.Autocomplete | null,
        onPlaceChanged: (place: google.maps.places.PlaceResult, generalAddress: GeneralAddress) => void
    ): void {
        // Check for the existence of the Google API
        const waitForGoogleAPI = setInterval(
            () => {
                if (window.google && window.google.maps && window.google.maps.places) {
                    clearInterval(waitForGoogleAPI); // Stop polling once Google API is available

                    try {
                        const inputElement = document.getElementById(inputElementId) as HTMLInputElement;

                        if (inputElement) {
                            console.log('inputElement: ', inputElement);
                            autocomplete = new google.maps.places.Autocomplete(inputElement, {
                                componentRestrictions: { country: ['us', 'ca'] },
                                fields: ['address_components', 'geometry'],
                                types: ['address'],
                            });

                            // Listener for successful place selection
                            autocomplete.addListener('place_changed', () => {
                                const place = autocomplete?.getPlace();
                                if (place && place.address_components) {
                                    const generalAddress = this.extractAddressFields(place);
                                    onPlaceChanged(place, generalAddress);
                                }
                            });

                            // Listener for error handling
                            google.maps.event.addListener(autocomplete, 'error', this.handleError);
                        } else {
                            console.log('inputElement is null', inputElement);
                        }
                    } catch (error) {
                        console.log('Failed to initialize autocomplete:', error);
                    }
                } else {
                    console.log('Waiting for Google Maps API to load...');
                }
            },
            100); // Check every 100ms
    }

    handleError = (error: any) => {
        console.log('Google Places API error:', error);
    }

    private extractAddressFields(place: google.maps.places.PlaceResult): GeneralAddress {
        const addressComponents = place.address_components || [];
        const addressLine1 = addressComponents
            .filter((comp) => comp.types.includes('street_number') || comp.types.includes('route'))
            .map((comp) => comp.long_name)
            .join(' ');

        const city = addressComponents.find((comp) => comp.types.includes('locality'))?.long_name || '';
        const state = addressComponents.find((comp) => comp.types.includes('administrative_area_level_1'))?.short_name || '';
        const zipCode = addressComponents.find((comp) => comp.types.includes('postal_code'))?.long_name || '';

        console.log('generated Address: ', { addressLine1, city, state, zipCode });
        return { addressLine1, city, state, zipCode };
    }

    // initMutipleAutocomplete(
    //     inputId: string,
    //     onPlaceChanged: (place: google.maps.places.PlaceResult, addressFields: AddressFields) => void
    // ): void {
    //     try {
    //         const inputElement = document.getElementById(inputId) as HTMLInputElement;
    //         if (inputElement) {
    //             const autocomplete = new google.maps.places.Autocomplete(inputElement, {
    //                 componentRestrictions: { country: ['us', 'ca'] },
    //                 fields: ['address_components', 'geometry'],
    //                 types: ['address'],
    //             });

    //             this.multipleAutocomplete[inputId] = autocomplete;

    //             // Listener for successful place selection
    //             autocomplete.addListener('place_changed', () => {
    //                 const place = this.autocomplete?.getPlace();
    //                 if (place && place.address_components) {
    //                     const addressFields = this.extractAddressFields(place);
    //                     onPlaceChanged(place, addressFields);
    //                 }
    //             });
    //             // Listener for adding eror handling
    //             google.maps.event.addListener(autocomplete, 'error', this.handleError);
    //         }
    //     } catch(error) {
    //         console.log('Failed to initialize autocomplete: ', error);
    //     }

    // }

    // destroyAutocomplete(): void {
    //     if (this.autocomplete) {
    //         google.maps.event.clearInstanceListeners(this.autocomplete);
    //         this.autocomplete = null;
    //     }
    // }

    // destroyAutocompleteByInputId(inputId: string): void {
    //     this.multipleAutocomplete[inputId] = null; // Remove reference
    // }
}


// WEBPACK FOOTER //
// ./src/utils/googleMapAPI.ts